module.exports = __webpack_public_path__ + "./kai-illustration_18346ddb1451ffc2bf86c3a1c517c4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2015/kai-illustration.png
// module id = 422
// module chunks = 0